import type { CoreBundlePayload, CoreItem, ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Update an item by ID.
 *
 * @endpoint PATCH /api/saas/me/bundles/{bundleId}
 * @scope saas
 * @see https://flecto.dev/api-12969323
 */
export async function updateBundle(
  bundleId: ParameterID,
  bundle: CoreBundlePayload
): Promise<CoreItem> {
  const { data } = await api.put(`/api/saas/me/bundles/${bundleId}`, bundle)

  return data.bundle
}
